/**
 * Defer selected third-party scripts until first user interaction.
 *
 * Shopify analytics (trekkie), Web Pixels Manager, asyncLoad, shopify_pay,
 * storefront, and app embed scripts must never be intercepted.
 */
(function () {
  var DEFERRED_SRC_PATTERNS = ['connect.facebook.net'];

  var NEVER_TOUCH_SRC_PATTERNS = [
    'shopify.com',
    'shopifycdn.com',
    'shopifysvc.com',
    'clarity.ms',
    'monorail',
    'trekkie',
    'web-pixels-manager',
    'shopifycloud',
    'cdn.shopify.com',
  ];

  var deferredScripts = [];
  var activated = false;

  function shouldNeverTouchScript(script) {
    if (!script || script.nodeType !== 1 || script.tagName !== 'SCRIPT') return true;
    if (script.className === 'analytics') return true;
    if (!script.src) return true;

    return NEVER_TOUCH_SRC_PATTERNS.some(function (pattern) {
      return script.src.indexOf(pattern) !== -1;
    });
  }

  function shouldDeferScript(script) {
    if (shouldNeverTouchScript(script)) return false;

    return DEFERRED_SRC_PATTERNS.some(function (pattern) {
      return script.src.indexOf(pattern) !== -1;
    });
  }

  function activateDeferredScripts() {
    if (activated) return;
    activated = true;

    deferredScripts.splice(0).forEach(function (script) {
      var src = script.getAttribute('data-src');
      if (!src || shouldNeverTouchScript(script)) return;

      script.src = src;
      script.removeAttribute('data-src');
    });
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!shouldDeferScript(node) || node.getAttribute('data-src')) return;

        node.setAttribute('data-src', node.src);
        node.removeAttribute('src');
        deferredScripts.push(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  ['keydown', 'mousemove', 'touchstart', 'scroll'].forEach(function (eventName) {
    window.addEventListener(eventName, activateDeferredScripts, {
      once: true,
      passive: true,
    });
  });
})();
